import React from 'react'
import CollegeFootball from 'src/components/page/college-football'
import { teamIds } from 'src/constants/personalizationIds'
export default (props) => (
  <CollegeFootball
    {...props}
    team="Oklahoma Sooners"
    hasGenericVideo={true}
    teamId={teamIds['Oklahoma Sooners']}
    poster="https://assets-imgx.fubo.tv/marketing/lp/images/posters/CFB/Sooners.png"
  />
)
